import { render } from "./ManageLearningCourse.vue?vue&type=template&id=9278a4a2&lang=pug"
import script from "./ManageLearningCourse.vue?vue&type=script&lang=js"
export * from "./ManageLearningCourse.vue?vue&type=script&lang=js"

import "./ManageLearningCourse.vue?vue&type=style&index=0&id=9278a4a2&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__